import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { ReduxUIStoreContext } from 'redux-ui';
import { QueryClientProvider } from 'resources/ReactQuery/QueryClientProvider';

import ExperimentProviderLayout from 'components/Amplitude/ExperimentProviderLayout';
import { Codeowners } from 'components/Common/Error/Codeowners';
import ErrorBoundary from 'components/Common/Error/ErrorBoundary';
import { LaunchDarklyAppProvider } from 'components/LaunchDarkly/LaunchDarklyProvider';
import ProIdentity from 'components/ProIdentity';

type IndividualBootstrapProps = {
  store: Store;
  children: React.ReactNode;
  codeowners?: Codeowners | undefined;
};

const IndividualBootstrap = ({ store, children, codeowners }: IndividualBootstrapProps) => (
  <Provider store={store}>
    <QueryClientProvider>
      <ReduxUIStoreContext.Provider value={{ store }}>
        <ErrorBoundary codeowners={codeowners}>
          <ProIdentity>
            <ExperimentProviderLayout>
              <LaunchDarklyAppProvider>
                <DndProvider backend={HTML5Backend}>
                  <>{children}</>
                </DndProvider>
              </LaunchDarklyAppProvider>
            </ExperimentProviderLayout>
          </ProIdentity>
        </ErrorBoundary>
      </ReduxUIStoreContext.Provider>
    </QueryClientProvider>
  </Provider>
);

export default IndividualBootstrap;
